import MyButton from "@/components/UI/MyButton";
import MyInput from "@/components/UI/MyInput";
import MyDialog from "@/components/UI/MyDialog";
import MySelect from "@/components/UI/MySelect";

export default [
    MyButton,
    MyInput,
    MyDialog,
    MySelect
]